import { render, staticRenderFns } from "./SendWebhook.vue?vue&type=template&id=47936b4b&scoped=true&"
import script from "./SendWebhook.vue?vue&type=script&lang=js&"
export * from "./SendWebhook.vue?vue&type=script&lang=js&"
import style0 from "./SendWebhook.vue?vue&type=style&index=0&id=47936b4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47936b4b",
  null
  
)

export default component.exports